export const ROUTES = {
  dashboard: '/',
  newsletterList: '/newsletters',
  newsletterCreate: '/newsletters/new',
  newsletterEdit: (id: string) => `/newsletters/${id}/edit`,
  newsletterPreview: (id: string) => `/newsletters/${id}/preview`,
  newsletterVersions: (id: string) => `/newsletters/${id}/versions`,
} as const;

export const ROUTE_PATTERNS = {
  dashboard: '/',
  newsletterList: '/newsletters',
  newsletterCreate: '/newsletters/new',
  newsletterEdit: '/newsletters/:id/edit',
  newsletterPreview: '/newsletters/:id/preview',
  newsletterVersions: '/newsletters/:id/versions',
} as const;
